import React, { useContext, useEffect, useState } from "react";

import { Subject } from "rxjs/internal/Subject";
import { distinctUntilChanged, map } from "rxjs/operators";
import { FormContext } from "./FormContext";
import { IFormState } from "./formInterfaces";
import { OnBeforeUnload } from "../../components/navigation/OnBeforeUnload";

type Props = {};

export const OnUnSaveChange: React.FC<Props> = () => {
  const { subscribe } = useContext(FormContext);
  const [changeUnSave, setChangeUnSave] = useState(false);

  useEffect(() => {
    const formStateObserver$ = new Subject<IFormState>();

    formStateObserver$
      .pipe(
        map(({ meta }) => ({
          changed: meta.changed
        })),
        distinctUntilChanged((next, prev) => next.changed === prev.changed)
      )
      .subscribe(({ changed }) => {
        setChangeUnSave(changed);
      });

    const formStateSubscription = subscribe(formStateObserver$);

    return () => {
      formStateSubscription.unsubscribe();
      formStateObserver$.complete();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!changeUnSave) return null;
  return <OnBeforeUnload />;
};
